/**
 * Action Types Constants
 * https://redux.js.org/basics/actions
 */

const UserConstants = {
  GET_USER_REQUEST: 'GET_USER_REQUEST',
  GET_USER_SUCCESS: 'GET_USER_SUCCESS',
  GET_USER_FAILED: 'GET_USER_FAILED',
  USER_LOGOUT: 'USER_LOGOUT',
}

export default UserConstants;
